import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Input } from 'reactstrap';
import t, { getCurrentLanguage } from "utils/Lang";

const LanguageSelector = ({ isShow, onLangSelected, onModalToggle }) => {
  const [modal, setModal] = useState(isShow || false);
  const [selectedLang, setSelectedLang] = useState(getCurrentLanguage() || 'vi');
  const toggle = () => {
    setModal(!modal);
    if (onModalToggle) {
        onModalToggle(!modal);
    }
  }
  const onSelectClick = () => {
    if (onLangSelected) {
        onLangSelected(selectedLang);
    }
    toggle();
  };
  return (
    <div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{t().nav__select_a_language}</ModalHeader>
        <ModalBody>
            <FormGroup>
                <Input
                    type="select"
                    value={selectedLang}
                    onChange={e => setSelectedLang(e.target.value)}
                >
                    <option value="vi">Tiếng Việt</option>
                    <option value="en">English</option>
                </Input>
            </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onSelectClick}>{t().action__save}</Button>{' '}
          <Button color="secondary" onClick={toggle}>{t().action__go_back}</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default LanguageSelector;